export default __webpack_public_path__ + "static/media/photo_gallery_7.73314c96.png";